// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"79":"a88c1756","126":"94f59810","175":"a88c1756","849":"2b25c289","860":"2b25c289","897":"2b25c289","996":"2b25c289"}[chunkId] + ".chunk.css";
};